export const THREAD_VIEW_FEATURE_SHEPHERDS_ALREADY_SEEN = 'messages:thread-view-feature-shepherds-already-seen';